import ascendEvents from './ascendEvents';
import utils from './utils';

export default {
  events: ascendEvents.ascendEvents,
  registerEvents: ascendEvents.registerEvents,
  biUtils: utils,
};
